import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const StyledButton = styled(motion.button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${props => props.size === 'large' ? '16px' : '12px'};
  background-color: ${props => props.variant === 'primary' ? '#6c5ce7' : 'transparent'};
  color: ${props => props.variant === 'primary' ? '#fff' : '#6c5ce7'};
  border: ${props => props.variant === 'primary' ? 'none' : '1px solid #6c5ce7'};
  border-radius: 12px;
  font-weight: 600;
  font-size: ${props => props.size === 'large' ? '16px' : '14px'};
  box-shadow: ${props => props.variant === 'primary' ? '0 4px 6px rgba(108, 92, 231, 0.2)' : 'none'};
  transition: all 0.3s ease;
  opacity: ${props => props.disabled ? '0.6' : '1'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    background-color: ${props => props.variant === 'primary' && !props.disabled ? '#5d4adb' : props.variant !== 'primary' && !props.disabled ? 'rgba(108, 92, 231, 0.05)' : ''};
    transform: ${props => !props.disabled ? 'translateY(-2px)' : 'none'};
    box-shadow: ${props => props.variant === 'primary' && !props.disabled ? '0 6px 10px rgba(108, 92, 231, 0.25)' : 'none'};
  }

  &:active {
    transform: ${props => !props.disabled ? 'translateY(1px)' : 'none'};
  }

  svg {
    margin-right: ${props => props.iconPosition === 'left' ? '8px' : '0'};
    margin-left: ${props => props.iconPosition === 'right' ? '8px' : '0'};
  }
`;

const Button = ({
    children,
    variant = 'primary',
    size = 'large',
    icon: Icon,
    iconPosition = 'left',
    isLoading,
    disabled,
    ...rest
}) => {
    return (
        <StyledButton
            variant={variant}
            size={size}
            iconPosition={iconPosition}
            disabled={disabled || isLoading}
            whileTap={{ scale: disabled || isLoading ? 1 : 0.98 }}
            {...rest}
        >
            {isLoading ? (
                <span>Carregando...</span>
            ) : (
                <>
                    {Icon && iconPosition === 'left' && <Icon size={size === 'large' ? 20 : 16} />}
                    {children}
                    {Icon && iconPosition === 'right' && <Icon size={size === 'large' ? 20 : 16} />}
                </>
            )}
        </StyledButton>
    );
};

export default Button;